import { Disclosure, Transition } from "@headlessui/react";
import React, { useState, useEffect } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import ChevronUpIcon from "../../assets/images/icon_profile/chevron.svg";
import { useTranslation } from "react-i18next";
import { getFaq } from "../../core/service/api";

const ComponentFAQ = () => {
  const { t } = useTranslation();
  const [faqData, setFaqData] = useState<any>([]);
  let faq = [
    {
      title: t("FAQ.one.title"),
      description: t("FAQ.one.description"),
    },
    {
      title: t("FAQ.two.title"),
      description: t("FAQ.two.description"),
    },
    {
      title: t("FAQ.three.title"),
      description: t("FAQ.three.description"),
    },
    {
      title: t("FAQ.four.title"),
      description: t("FAQ.four.description"),
    },
    {
      title: t("FAQ.five.title"),
      description: t("FAQ.five.description"),
    },
  ];

  const getDataFaq = () => {
    getFaq("PSPMOBILE", "id", "HOME").then(
      (res) => {
        setFaqData(res.data);
        // console.log(res);
      },
      (err) => {}
    );
  };

  useEffect(() => {
    getDataFaq();
  }, []);

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile name={`${t("FAQ.title")}`} backUrl={"profile"}></TabsMobile>
      </div>
      <section className="flex py-6 top-to-bottom">
        <div className="flex flex-col gap-2.5 mx-4 w-full">
          {faqData.map((res: any) => (
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className={`${
                      open
                        ? "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-2 text-left text-sm font-semibold rounded-lg border border-psp-primary"
                        : "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-2 text-left text-sm font-semibold rounded-lg border border-psp-primary"
                    }`}
                  >
                    <span className="w-4/5">{res.question}</span>
                    <img
                      src={ChevronUpIcon}
                      className={`${
                        open ? "rotate-0 transform" : ""
                      } h-3 w-3 text-purple-500 rotate-180 transform`}
                    />
                  </Disclosure.Button>
                  <Transition
                    show={open}
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Disclosure.Panel
                      style={{ backgroundColor: "#0054e61a" }}
                      className="px-4 pb-2 py-2 -mt-2.5 text-xs font-normal text-black rounded-b-xl mx-2"
                    >
                      <span className="text-black font-montserrat">
                        {res.answer}
                      </span>
                      <img hidden={!res.image} src={res.image} />
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ComponentFAQ;
